enum CarnetImageType {
    Front = '1',
    Back = '-1'
}

export default CarnetImageType;
